import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { Component, Input, OnInit } from '@angular/core';
import { faCalendarAlt,faClock,  faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { BookingService } from 'src/app/services/booking.service';

@Component({
  selector: 'view-my-car',
  templateUrl: './view-my-car.component.html',
  styleUrls: ['./view-my-car.component.css']
})
export class ViewMyCarComponent implements OnInit {

  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;
  faClock=faClock;
  faCalendarAlt=faCalendarAlt;

  constructor(private bookinService:BookingService) { }
  viewBooking:ViewBookingModel;
  @Input() reservationCaseResult;
  ngOnInit() {
    this.bookinService.viewBookingModel.subscribe(res =>{
      this.viewBooking=res;
    })
  }

}
